import "./styles.scss";
import { Events } from "../../js/events";
import { EventDetails } from "../../js/event-details";

const events = new Events();
const eventDetails = new EventDetails();